/**************
 Global
 ***************/

const urlParams = new URLSearchParams(window.location.search);

// root
const root = window.location.href.includes("127.0.0.1") ? "http://localhost:3000" : "https://api.plantpaper.com";

// keep multipass-flow customers on the page: while from_multipass is in the url, the header account
// icon must not navigate them away from the upsell
if (urlParams.has("from_multipass")) {
    document.querySelector("#headerBodyIconsAccount").classList.add("deactivate");
}

// get index of a specific element
function getElIndex(el) {
    let i;
    for (i = 0; el = el.previousElementSibling; i++) ;
    return i;
}

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { '_added_at': Date.now() } };
function addProduct(formData) {
    // klaviyo tracking
    try {
        _learnq.push(['track', 'Added to Cart', item]);
    } catch (error) {
        console.error("Klaviyo tracking not found");
    }

    return fetch('/cart/add.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 };
function changeProduct(formData) {
    return fetch('/cart/change.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}

//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
function updateCart(formData) {
    return fetch('/cart/update.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}

//download product
function downloadProduct(handle) {
    return fetch(`/products/${handle}.js`)
        .then(function (data) {
            return data.json();
        })
        .then(function (data) {
            return data;
        })
        .catch((error) => {
            return false;
        });
}


// print price ($51.27 = 5127)
function price(amount) {
    let total = (parseFloat(amount) / 100).toFixed(2);
    return `${currency}${total.replace(".00", "")}`;
}

// sleep
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}


// Function to send back in stock subscription to Klaviyo
async function sendKlaviyoBackInStockRequest(emailAddress, variantID) {
    await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${await klaviyo.account()}`, {
        method: 'POST',
        headers: {
            accept: 'application/vnd.api+json',
            revision: '2024-10-15',
            'content-type': 'application/vnd.api+json'
        },
        body: JSON.stringify({
            data: {
                type: "back-in-stock-subscription",
                attributes: {
                    channels: ["EMAIL"],
                    profile: {
                        data: {
                            type: "profile",
                            attributes: {
                                email: emailAddress,
                            }
                        }
                    }
                },
                relationships: {
                    variant: {
                        data: {
                            type: "catalog-variant",
                            id: `$shopify:::$default:::${variantID}`,
                        }
                    }
                }
            }
        })
    })
}

async function retrieveLocation() {
    return await fetch("https://geoip.maltertech.com/").then(response => response.json()).catch(error => {
        console.error("Error retrieving location:", error);
        return null;
    });
}

// function on PDP swiper elements to allow videos to full play before sliding to next slide
function handleSlideAutoplay(swiper) {

    swiper.el.querySelectorAll("video").forEach(v => v.pause());

    const activeSlide = swiper.slides[swiper.activeIndex];
    const video = activeSlide.querySelector("video");

    // if the slide is a video:
    // 1.) Halt the swiper autoplay
    // 2.) Make sure video is at start
    // 3.) Play video
    // 4.) Once ended, slide to next slide and resume autoplay (if not video)
    if (video) {
        swiper.autoplay.stop();
        video.currentTime = 0;
        video.play();
        video.addEventListener("ended", function () {
            swiper.slideNext();
        }, {once: true});
    } else {
        swiper.autoplay.start();
    }
}

/**********
 Klaviyo Viewed Product Events
 **********/

if (["/pages/plant-paper", "/pages/tissues", "/pages/paper-towel"].includes(window.location.pathname)) {
    try {
        let klaviyo = window.klaviyo || [];
        klaviyo.push(["track", "Viewed Product", {
            url: window.location.pathname
        }]);
    } catch (e) {
        console.error("Klaviyo tracking not found: ", e);
    }
}